export function berechneVerbundfestigkeit(
  verbundbedingungen,
  beiwert_eta2,
  druckfestigkeitZement,
  teilsicherheitsbeiwert
) {
  return (
    2.25 * verbundbedingungen * beiwert_eta2 * (druckfestigkeitZement / teilsicherheitsbeiwert)
  );
}

export function berechneUebertragungslaenge(bemessungslast, durchmesser, verbundfestigkeit) {
  return bemessungslast / (Math.PI * durchmesser * verbundfestigkeit);
}

export function berechneBondStrength(
  verbundbedingungen,
  beiwert_eta2,
  druckfestigkeitZement,
  teilsicherheitsbeiwert
) {
  return (
    2.225 * verbundbedingungen * beiwert_eta2 * (druckfestigkeitZement / teilsicherheitsbeiwert)
  );
}
